import tw, { styled, css } from 'twin.macro';
import Link from '../Link/Link';
import { variants } from '../Link/Link.styles';

export const StyledWrapper = styled.div<{
  isSticky: boolean;
}>`
  ${tw`sticky`}
  ${tw`top-0`}
  ${tw`w-full`}
  ${tw`z-40`}
  ${({ isSticky }) => !isSticky && tw`relative lg:top-[unset]`}
`;

export const StyledHeader = styled.header`
  ${tw`bg-neutrals-n1/90`}
  ${tw`backdrop-blur-lg`}
  ${tw`px-[20px] lg:px-[33px]`}
  ${tw`flex items-center`}
  ${tw`h-[72px]`}
  ${tw`border-solid border-b-2 border-ui-colours-ui3`}
`;

export const StyledMenuItems = styled.ul<{ isMobileNavOpen: boolean; offset: string }>`
  ${tw`bg-neutrals-n1 lg:bg-transparent`}
  ${tw`absolute top-[72px] left-0 lg:static lg:top-[unset] lg:left-[unset]`}
  ${tw`h-0 w-fullscreen lg:w-auto lg:h-auto`}
  ${tw`overflow-hidden lg:overflow-visible`}
  ${tw`transition-[height] duration-300 ease-in-out`}
  ${tw`lg:flex lg:gap-[32px] lg:justify-center`}

  ${({ isMobileNavOpen, offset }) =>
    isMobileNavOpen &&
    css`
      height: calc(100vh - ${offset}px);
    `}
`;

export const StyledMobileCTASectionWrapper = styled.li`
  ${tw`md:hidden`}
`;

export const StyledContainer = styled.nav`
  ${tw`lg:container flex justify-between lg:justify-normal`}
  ${tw`lg:gap-6`}
  ${tw`w-full h-full`}
`;

export const StyledLogoWrapper = styled.div`
  ${tw`col-span-3 lg:col-span-2`}
  ${tw`flex items-center shrink-0`}
    /* display logo ASAP without fade-in transition */
  img {
    ${tw`!transition-none`}
    ${tw`!opacity-100`}
    ${tw`h-[40px]`}
  }
`;

export const StyledCtaWrapper = styled.div`
  ${tw`hidden`}
  ${tw`md:h-full`}
  ${tw`md:flex md:items-center`}
`;

export const ButtonsWrapper = styled.div`
  ${tw`flex items-center justify-end`}
  ${tw`md:grow md:justify-end`}
  ${tw`gap-1 md:gap-2 lg:gap-[22px]`}
  ${tw`-mr-[10px] md:mr-0`}
`;

export const StyledMenuItemWrapper = styled.li`
  ${tw`flex`}
`;

export const StyledMenuLink = styled(Link)`
  ${variants.nav_text_link}
  ${tw`flex`}
  ${tw`w-full`}
  ${tw`px-[20px] py-[21px] lg:py-0 lg:px-0`}
`;
